var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H11V8C11 7.44772 11.4477 7 12 7Z",
    fill: "#929A9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1C6.40137 1 4.32218 1.5136 2.91789 2.91789C1.5136 4.32218 1 6.40137 1 9V15C1 17.5986 1.5136 19.6778 2.91789 21.0821C4.32218 22.4864 6.40137 23 9 23H15C17.5986 23 19.6778 22.4864 21.0821 21.0821C22.4864 19.6778 23 17.5986 23 15V9C23 6.40137 22.4864 4.32218 21.0821 2.91789C19.6778 1.5136 17.5986 1 15 1H9ZM3 9C3 6.59863 3.4864 5.17782 4.33211 4.33211C5.17782 3.4864 6.59863 3 9 3H15C17.4014 3 18.8222 3.4864 19.6679 4.33211C20.5136 5.17782 21 6.59863 21 9V15C21 17.4014 20.5136 18.8222 19.6679 19.6679C18.8222 20.5136 17.4014 21 15 21H9C6.59863 21 5.17782 20.5136 4.33211 19.6679C3.4864 18.8222 3 17.4014 3 15V9Z",
    fill: "#929A9B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare);
export default __webpack_public_path__ + "static/media/AddSquare.2cf48a32b6d4e88eb834cfe07229364b.svg";
export { ForwardRef as ReactComponent };